import urls from './urls';
import axios from 'axios';
import { addParamsToQueryString } from '../functions/utils';
import { IApiResponse } from 'redhotpie-shared-lib/interfaces/IApiResponse';

class memberProfileApi {
  static getMemberProfile(userId: number): Promise<IApiResponse> {
    // this.restClient = new RestClient();
    // this.restClient.setBaseUrl(urls.BASE_RHPURL);
    const url = urls.GET_MEMBER_PROFILE.replace('{id}', userId.toString());
    // return this.restClient.execute(url, ApiMethod.GET);
    return axios.get(url, { baseURL: urls.BASE_RHPURL, headers: { isAnonymous: false } });
  }
  // TODO: Check if customHeader is needed
  static getMemberPhoto(userId: number): Promise<IApiResponse> {
    // this.restClient = new RestClient();
    // this.restClient.setBaseUrl(urls.BASE_RHPURL);
    const url = urls.GET_MEMBER_PROFILE_PHOTO.replace('{id}', userId.toString());
    // return this.restClient.execute(url, ApiMethod.GET, null, false, false, false, false, customHeader);
    return axios.get(url, { baseURL: urls.BASE_RHPURL, headers: { isAnonymous: false } });
  }
  static getPhotoLikes(photoId: number, params: any): Promise<IApiResponse> {
    const url = addParamsToQueryString(urls.GET_PHOTO_LIKES.replace('{PhotoID}', photoId.toString()), params);
    return axios.get(url, { baseURL: urls.BASE_RHPURL, headers: { isAnonymous: false } });
  }
  static createUserPhotoLike(photoId: number): Promise<IApiResponse> {
    const url = urls.CREATE_USER_PHOTO_LIKE.replace('{PhotoID}', photoId.toString());
    return axios.post(url, null, { baseURL: urls.BASE_RHPURL, headers: { isAnonymous: false } });
  }
  static deleteUserPhotoLike(photoId: number): Promise<IApiResponse> {
    const url = urls.DELETE_USER_PHOTO_LIKE.replace('{PhotoID}', photoId.toString());
    return axios.patch(url, null, { baseURL: urls.BASE_RHPURL, headers: { isAnonymous: false } });
  }

  static getProfileGallery(userId: number): Promise<IApiResponse> {
    // this.restClient = new RestClient();
    // this.restClient.setBaseUrl(urls.BASE_RHPURL);
    const url = urls.GET_MEMBER_PROFILE_GALLERY.replace('{id}', userId.toString());
    // return this.restClient.execute(url, ApiMethod.GET);
    return axios.get(url, { baseURL: urls.BASE_RHPURL, headers: { isAnonymous: false } });
  }

  static getMemberPhotoAmateur(userId: number): Promise<IApiResponse> {
    // this.restClient = new RestClient();
    // this.restClient.setBaseUrl(urls.BASE_RHPURL);
    const url = urls.GET_MEMBER_PROFILE_AMATEUR_DATA.replace('{id}', userId.toString());
    // return this.restClient.execute(url, ApiMethod.GET);
    return axios.get(url, { baseURL: urls.BASE_RHPURL, headers: { isAnonymous: false } });
  }

  static getMemberValidates(userId: number, params: any): Promise<IApiResponse> {
    // this.restClient = new RestClient();
    // this.restClient.setBaseUrl(urls.BASE_RHPURL);
    const url = addParamsToQueryString(urls.GET_MEMBER_VALIDATE.replace('{id}', userId.toString()), params);
    // return this.restClient.execute(url, ApiMethod.GET, params);
    return axios.get(url, { baseURL: urls.BASE_RHPURL, headers: { isAnonymous: false } });
  }

  static getMemberFriends(userId: number, params: any): Promise<IApiResponse> {
    // this.restClient = new RestClient();
    // this.restClient.setBaseUrl(urls.BASE_RHPURL);
    const url = addParamsToQueryString(urls.GET_MEMBER_FRIENDS.replace('{id}', userId.toString()), params);
    // return this.restClient.execute(url, ApiMethod.GET, params);
    return axios.get(url, { baseURL: urls.BASE_RHPURL, headers: { isAnonymous: false } });
  }

  static getMemberTravelPlans(userId: number): Promise<IApiResponse> {
    // this.restClient = new RestClient();
    // this.restClient.setBaseUrl(urls.BASE_RHPURL);
    const url = urls.GET_MEMBER_TRAVEL_PLAN.replace('{id}', userId.toString());
    // return this.restClient.execute(url, ApiMethod.GET);
    return axios.get(url, { baseURL: urls.BASE_RHPURL, headers: { isAnonymous: false } });
  }

  static getMemberDateFinder(userId: number): Promise<IApiResponse> {
    // this.restClient = new RestClient();
    // this.restClient.setBaseUrl(urls.BASE_RHPURL);
    const url = urls.GET_MEMBER_DATE_FINDER.replace('{id}', userId.toString());
    // return this.restClient.execute(url, ApiMethod.GET);
    return axios.get(url, { baseURL: urls.BASE_RHPURL, headers: { isAnonymous: false } });
  }

  static postCreateDateFinderInterest(id: number): Promise<IApiResponse> {
    // this.restClient = new RestClient();
    // this.restClient.setBaseUrl(urls.BASE_RHPURL);
    const url = urls.POST_CREATE_DATE_FINDER_INTEREST.replace('{id}', id.toString());
    // return this.restClient.execute(url, ApiMethod.POST);
    return axios.post(url, null, { baseURL: urls.BASE_RHPURL, headers: { isAnonymous: false } });
  }

  static postCreateDateFinderUnInterest(id: number): Promise<IApiResponse> {
    // this.restClient = new RestClient();
    // this.restClient.setBaseUrl(urls.BASE_RHPURL);
    const url = urls.POST_CREATE_DATE_FINDER_UNINTEREST.replace('{id}', id.toString());
    // return this.restClient.execute(url, ApiMethod.POST);
    return axios.post(url, null, { baseURL: urls.BASE_RHPURL, headers: { isAnonymous: false } });
  }

  static postCreateValidation(userId: number, params: any): Promise<IApiResponse> {
    // this.restClient = new RestClient();
    // this.restClient.setBaseUrl(urls.BASE_RHPURL);
    const url = urls.POST_MEMBER_CREATE_VALIDATION.replace('{id}', userId.toString());
    // return this.restClient.execute(url, ApiMethod.POST, params);
    return axios.post(url, params, { baseURL: urls.BASE_RHPURL, headers: { isAnonymous: false } });
  }

  static patchUpdateValidation(userId: number, params: any): Promise<IApiResponse> {
    // this.restClient = new RestClient();
    // this.restClient.setBaseUrl(urls.BASE_RHPURL);
    const url = urls.POST_MEMBER_CREATE_VALIDATION.replace('{id}', userId.toString());
    // return this.restClient.execute(url, ApiMethod.DELETE, params);
    return axios.delete(url, { baseURL: urls.BASE_RHPURL, headers: { isAnonymous: false }, data: params });
  }

  static postCreateFriend(userId: number, params: any): Promise<IApiResponse> {
    // this.restClient = new RestClient();
    // this.restClient.setBaseUrl(urls.BASE_RHPURL);
    const url = urls.POST_MEMBER_CREATE_FRIEND.replace('{id}', userId.toString());
    // return this.restClient.execute(url, ApiMethod.POST, params);
    return axios.post(url, params, { baseURL: urls.BASE_RHPURL, headers: { isAnonymous: false } });
  }

  static patchUpdateFriend(params: any): Promise<IApiResponse> {
    // this.restClient = new RestClient();
    // this.restClient.setBaseUrl(urls.BASE_RHPURL);
    const url = urls.PATCH_MEMBER_PROFILE_FRIEND;
    // return this.restClient.execute(url, ApiMethod.PATCH, params);
    return axios.patch(url, params, { baseURL: urls.BASE_RHPURL, headers: { isAnonymous: false } });
  }

  static getProfileNote(userId: number): Promise<IApiResponse> {
    // this.restClient = new RestClient();
    // this.restClient.setBaseUrl(urls.BASE_RHPURL);
    const url = urls.MEMBER_PROFILE_NOTE.replace('{id}', userId.toString());
    // return this.restClient.execute(url, ApiMethod.GET, params);
    return axios.get(url, { baseURL: urls.BASE_RHPURL, headers: { isAnonymous: false } });
  }

  static postCreateNote(userId: number, params: any): Promise<IApiResponse> {
    // this.restClient = new RestClient();
    // this.restClient.setBaseUrl(urls.BASE_RHPURL);
    const url = urls.MEMBER_PROFILE_NOTE.replace('{id}', userId.toString());
    // return this.restClient.execute(url, ApiMethod.POST, params);
    return axios.post(url, params, { baseURL: urls.BASE_RHPURL, headers: { isAnonymous: false } });
  }

  static patchUpdateNote(nodeId: number, params: any): Promise<IApiResponse> {
    // this.restClient = new RestClient();
    // this.restClient.setBaseUrl(urls.BASE_RHPURL);
    const url = urls.PATCH_MEMBER_PROFILE_NOTE.replace('{id}', nodeId.toString());
    // return this.restClient.execute(url, ApiMethod.PATCH, params);
    return axios.patch(url, params, { baseURL: urls.BASE_RHPURL, headers: { isAnonymous: false } });
  }

  static getFriendCount(userId: number): Promise<IApiResponse> {
    // this.restClient = new RestClient();
    // this.restClient.setBaseUrl(urls.BASE_RHPURL);
    const url = urls.GET_MEMBER_FRIENDS_COUNT.replace('{id}', userId.toString());
    // return this.restClient.execute(url, ApiMethod.GET);
    return axios.get(url, { baseURL: urls.BASE_RHPURL, headers: { isAnonymous: false } });
  }

  static getValidationCount(userId: number): Promise<IApiResponse> {
    // this.restClient = new RestClient();
    // this.restClient.setBaseUrl(urls.BASE_RHPURL);
    const url = urls.GET_MEMBER_VALIDATION_COUNT.replace('{id}', userId.toString());
    // return this.restClient.execute(url, ApiMethod.GET);
    return axios.get(url, { baseURL: urls.BASE_RHPURL, headers: { isAnonymous: false } });
  }

  static postCreateBlockUser(userId: number): Promise<IApiResponse> {
    // this.restClient = new RestClient();
    // this.restClient.setBaseUrl(urls.BASE_RHPURL);
    const url = urls.BLOCK_USER.replace('{userId}', userId.toString());
    // return this.restClient.execute(url, ApiMethod.POST);
    return axios.post(url, null, { baseURL: urls.BASE_RHPURL, headers: { isAnonymous: false } });
  }

  static postCreateReportUser(userId: number, params: any): Promise<IApiResponse> {
    // this.restClient = new RestClient();
    // this.restClient.setBaseUrl(urls.BASE_RHPURL);
    const url = urls.CREATE_ABUSE_REPORT.replace('{userId}', userId.toString());
    // return this.restClient.execute(url, ApiMethod.POST, params);
    return axios.post(url, params, { baseURL: urls.BASE_RHPURL, headers: { isAnonymous: false } });
  }

  static postCreateProfileView(id: number): Promise<IApiResponse> {
    const url = urls.POST_CREATE_PROFILE_VIEW.replace('{Id}', id.toString());

    return axios.post(url, null, { baseURL: urls.BASE_RHPURL, headers: { isAnonymous: false } });
  }
  static checkPhotoStatus(id: number): Promise<IApiResponse> {
    const url = urls.CHECK_PHOTO_STATUS.replace('{PhotoID}', id.toString());
    return axios.get(url, { baseURL: urls.BASE_RHPURL, headers: { isAnonymous: false } });
  }
  static getProfileActivity(id: number): Promise<IApiResponse> {
    const url = urls.GET_PROFILE_ACTIVITY.replace('{Id}', id.toString());
    return axios.get(url, { baseURL: urls.BASE_RHPURL, headers: { isAnonymous: false } });
  }
  static getProfileGroups(userId: number, { page = 1, size = 5 }): Promise<IApiResponse> {
    return axios.get(`${urls.GET_PROFILE_GROUPS.replace('{id}', userId.toString())}?Page=${page}&Size=${size}`, {
      baseURL: urls.BASE_RHPURL,
      headers: { isAnonymous: false },
    });
  }
}

export default memberProfileApi;
